import React, { Component } from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import RefreshIcon from "@mui/icons-material/Refresh";
import CopyButton from "../CopyButton/CopyButton";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary capturou uma falha não tratada:", error, errorInfo);
    this.setState({ errorInfo });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const errorText = [
        `Erro: ${this.state.error?.message || String(this.state.error)}`,
        this.state.error?.stack ? `\nStack:\n${this.state.error.stack}` : null,
        this.state.errorInfo?.componentStack
          ? `\nComponent Stack:\n${this.state.errorInfo.componentStack}`
          : null,
      ]
        .filter(Boolean)
        .join("\n");

      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            backgroundColor: "rgb(240, 242, 245)",
            p: 2,
          }}
        >
          <Paper
            elevation={4}
            sx={{
              maxWidth: 600,
              width: "100%",
              p: 4,
              borderRadius: 3,
              textAlign: "center",
            }}
          >
            <ErrorOutlineIcon sx={{ fontSize: 60, color: "error.main", mb: 2 }} />
            <Typography variant="h5" component="h1" gutterBottom sx={{ fontWeight: 600 }}>
              Ocorreu um erro inesperado
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              A aplicação encontrou uma falha. Você pode copiar os detalhes do erro para relatar ou tentar recarregar a página.
            </Typography>

            <Box
              component="pre"
              sx={{
                p: 2,
                mb: 3,
                maxHeight: 180,
                overflowY: "auto",
                backgroundColor: "rgba(0, 0, 0, 0.05)",
                borderRadius: 1.5,
                fontSize: "0.75rem",
                fontFamily: "monospace",
                textAlign: "left",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                userSelect: "text",
              }}
            >
              {errorText}
            </Box>

            <Box sx={{ display: "flex", gap: 2, justifyContent: "center", flexWrap: "wrap" }}>
              <CopyButton
                text={errorText}
                label="Copiar detalhes do erro"
                variant="button"
                color="error"
              />
              <Button
                variant="contained"
                color="primary"
                startIcon={<RefreshIcon />}
                onClick={this.handleReload}
                sx={{ textTransform: "none" }}
              >
                Recarregar página
              </Button>
            </Box>
          </Paper>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
